var React = require('react');

function Stroke2Blue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#2E56B4","strokeWidth":"13","d":"M1477 5s-246 7-402 58c-168 55-273 208-477 243-203 36-409-108-634-97"}));
}

Stroke2Blue.defaultProps = {"viewBox":"0 0 1440 319"};

module.exports = Stroke2Blue;

Stroke2Blue.default = Stroke2Blue;
